// BLE is initialized with androidNeverForLocation, so Android needs the location service for BLE
// only up to Android 11 (API 30). Takes the result of Device.getInfo().
export const isLocationNeededForBle = (deviceInfo) => !(deviceInfo?.androidSDKVersion >= 31)
